import { Component, OnInit, OnDestroy } from '@angular/core'
import { NotificationService, MessageObject } from '@services/notification.service'
import { CoreComponent } from '@core/core.component'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends CoreComponent implements OnInit, OnDestroy {
  title = 'KIM'

  // error handling
  display = false
  errors = ''
  messageObject: MessageObject

  constructor(private notificationService: NotificationService) {
    super()
  }

  ngOnInit(): void {
    // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    // Add 'implements OnInit' to the class.
    // subscribe error messages
    this.subscription.add(
      this.notificationService.errors.subscribe((messageObject) => {
        if (messageObject) {
          this.messageObject = messageObject
          this.display = true
        }
      })
    )
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }
}
